export const MODAL_WIDTH = 'calc(100vw - 7.5rem)';
export const MODAL_X_OFFSET = '3.75rem';
export const MODAL_HEIGHT = 'calc(100vh - 9.625rem)';
